import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TopBarService {
  private readonly _isTopBarVisible = signal(false);

  public readonly isTopBarVisible = this._isTopBarVisible.asReadonly();

  public setTopBarOpen(state: boolean): void {
    this._isTopBarVisible.set(!!state);
  }
}
